function initSearchTyping(){
const reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  const terms=['face paints','hair chalks','craft kits','arts & crafts'];

  document.querySelectorAll('.search-bar_input').forEach(input=>{
    if(input.dataset.typingInit)return;
    input.dataset.typingInit='true';

    let term=0,char=0,deleting=false,paused=false;

    function type(){
if(reduce){
  input.placeholder='Search here...';
  return;
}

      if(paused||input.value){
        setTimeout(type,400);
        return;
      }

      const word=terms[term];
      input.placeholder='Search '+word.slice(0,char)+'…';

      if(!deleting){
        if(char<word.length){
          char++;
          setTimeout(type,75);
        }else{
          deleting=true;
          setTimeout(type,1400);
        }
      }else{
        if(char>0){
          char--;
          setTimeout(type,35);
        }else{
          deleting=false;
          term=(term+1)%terms.length;
          setTimeout(type,250);
        }
      }
    }

    input.addEventListener('focus',()=>{
      paused=true;
      input.placeholder='Search here...';
    });

    input.addEventListener('blur',()=>{
      paused=false;
      type();
    });

    type();
  });
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',initSearchTyping);
}else{
  initSearchTyping();
}